<template>
    <div class="h-full">
        <div class="block md:hidden">
            <div class="text-center pt-6 pb-6">
                <div class="flex justify-center">
                    <ImageQuestion class="mb-2" :size="'small'" :path="quizImage"></ImageQuestion>
                </div>
                <h1
                    class="theme-question-text-color theme-question-shadow my-0 text-white uppercase font-size-30 font-bold"
                >
                    {{ title }}
                </h1>
            </div>
            <div class="overflow-y-scroll">
                <div class="mb-6" :key="result.id" v-for="result in summary">
                    <div class="flex justify-center">
                        <ImageQuestion
                            v-if="result.questionImage"
                            class="mb-2"
                            :size="'tiny'"
                            :path="result.questionImage"
                        ></ImageQuestion>
                    </div>
                    <p
                        class="theme-question-text-color theme-question-shadow text-center font-size-18 font-bold uppercase text-white"
                    >
                        - {{ result.title }} -
                    </p>
                    <p class="text-center font-size-22 font-bold uppercase text-white flex items-center justify-center">
                        <span
                            v-if="result.image"
                            class="rounded-full mr-2 bg-center bg-norepeat bg-cover w-12 h-12 mt-2 border-2 border-solid border-white inline-block"
                            :style="{ 'background-image': 'url(' + result.image + ')' }"
                        ></span>
                        <span v-if="result.mostSelected.length">{{ result.mostSelected }}</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="hidden md:block h-full">
            <div class="flex w-full h-full">
                <div
                    class="w-1/2 h-full pt-12 border-r border-l-0 border-t-0 border-b-0 border-solid border-white"
                    style="border-color: var(--ui-color)"
                >
                    <div class="flex h-full text-white uppercase items-center justify-start flex-col">
                        <div
                            v-if="quizImage"
                            :style="{ 'background-image': 'url(' + quizImage + ')' }"
                            class="bg-cover bg-center bg-norepeat border-3 h-64 w-64 mb-4 rounded-lg border-solid border-white"
                        ></div>
                        <p
                            class="theme-question-text-color theme-question-shadow my-0 text-white uppercase font-size-30 font-bold"
                        >
                            {{ title }}
                        </p>
                    </div>
                </div>
                <div class="w-1/2 overflow-y-scroll">
                    <div class="flex items-center justify-center flex-col">
                        <div class="mb-6" :key="result.id" v-for="result in summary">
                            <div class="flex justify-center" v-if="result.questionImage">
                                <ImageQuestion class="mb-6" :size="'tiny'" :path="result.questionImage"></ImageQuestion>
                            </div>

                            <p
                                class="theme-question-text-color theme-question-shadow text-center font-size-18 font-bold uppercase text-white"
                            >
                                - {{ result.title }} -
                            </p>
                            <p
                                class="theme-question-text-color theme-question-shadow text-center uppercase font-size-22 font-bold text-white flex items-center justify-center"
                            >
                                <span
                                    v-if="result.image"
                                    class="rounded-full mr-2 bg-center bg-norepeat bg-cover w-16 h-16 mt-2 border-2 border-solid border-white inline-block"
                                    :style="{ 'background-image': 'url(' + result.image + ')' }"
                                ></span>
                                <span v-if="result.mostSelected.length">{{ result.mostSelected }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageQuestion from '@/components/ImageQuestion.vue'

export default {
    components: {
        ImageQuestion
    },

    props: {
        title: String,
        summary: Array,
        quizImage: String
    },

    data: function () {
        return {}
    },

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    }
}
</script>
